// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AddModal_modalOverlay__R2eV4 {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.AddModal_modal__-RSe1 {
  background: white;
  padding: 24px;
  border-radius: 12px;
  width: 400px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.AddModal_modalActions__3PINQ {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
}

.AddModal_modal__-RSe1 input {
  padding: 8px;
  font-size: 14px;
  border-radius: 4px;
  border: 1px solid #ccc;
}

.AddModal_inputError__t\\+EEu {
  border: 1px solid red;
}

.AddModal_error__yxX26 {
  color: red;
  font-size: 12px;
  margin-top: -8px;
  margin-bottom: 8px;
}

.AddModal_headText__\\+FtMX {
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 10px;
}

.AddModal_cancel__uFQIu {
  padding: 9px 20px;
  background: none;
  color: rgba(115, 115, 115, 1);
  border: 1px solid rgba(115, 115, 115, 1);
  border-radius: 4px;
  cursor: pointer;
}

.AddModal_save__FIp3u {
  padding: 9px 20px;
  background: rgba(29, 135, 82, 1);
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/styles/AddModal.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;EAC7B,wCAAwC;EACxC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB","sourcesContent":[".modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0,0,0,0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.modal {\n  background: white;\n  padding: 24px;\n  border-radius: 12px;\n  width: 400px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.modalActions {\n  margin-top: 10px;\n  display: flex;\n  justify-content: space-between;\n}\n\n.modal input {\n  padding: 8px;\n  font-size: 14px;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n}\n\n.inputError {\n  border: 1px solid red;\n}\n\n.error {\n  color: red;\n  font-size: 12px;\n  margin-top: -8px;\n  margin-bottom: 8px;\n}\n\n.headText {\n  font-weight: bold;\n  font-size: 18px;\n  margin-bottom: 10px;\n}\n\n.cancel {\n  padding: 9px 20px;\n  background: none;\n  color: rgba(115, 115, 115, 1);\n  border: 1px solid rgba(115, 115, 115, 1);\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.save {\n  padding: 9px 20px;\n  background: rgba(29, 135, 82, 1);\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalOverlay": `AddModal_modalOverlay__R2eV4`,
	"modal": `AddModal_modal__-RSe1`,
	"modalActions": `AddModal_modalActions__3PINQ`,
	"inputError": `AddModal_inputError__t+EEu`,
	"error": `AddModal_error__yxX26`,
	"headText": `AddModal_headText__+FtMX`,
	"cancel": `AddModal_cancel__uFQIu`,
	"save": `AddModal_save__FIp3u`
};
export default ___CSS_LOADER_EXPORT___;
